// Mount Splide JS
import Splide from "/modules/splide/splide.min.js";
if (typeof window !== "undefined") {
  window.Splide = Splide;
}

// Contact Form 7 validation messages
document.addEventListener('DOMContentLoaded', function () {
	document.body.classList.add('ready');

	// Get all Contact Form 7 form controls inputs, selects, etc.
	const formControls = document.querySelectorAll('.wpcf7-form-control');

	// Loop through each form control
	formControls.forEach(function (field) {
		['click', 'input', 'change'].forEach(function (eventType) {
			field.addEventListener(eventType, function () {
				const wrapper = field.closest('.wpcf7-form-control-wrap');
				if (!wrapper) return;
				const tip = wrapper.querySelector('.wpcf7-not-valid-tip');
				if (tip) {
					tip.style.transition = 'opacity 0.3s ease';
					tip.style.opacity = '0';
					setTimeout(() => {
						tip.style.display = 'none';
					}, 300);
				}
			});
		});
	});
});

document.addEventListener('DOMContentLoaded', function () {
  var fields = document.querySelectorAll(
    '.wpcf7-form .form-floating .form-control, ' +
    '.wpcf7-form .form-floating .form-select'
  );

  fields.forEach(function (field) {
    var wrapper = field.closest('.form-floating');
    if (!wrapper) return;

    function updateState() {
      if (field === document.activeElement || field.value.trim() !== '') {
        wrapper.classList.add('is-active');
      } else {
        wrapper.classList.remove('is-active');
      }
    }

    field.addEventListener('focus', updateState);
    field.addEventListener('blur', updateState);
    field.addEventListener('input', updateState);

    updateState();
  });
});

(function () {
    const header = document.querySelector('.site-header'); // change if your header class differs
    if (!header) return;

    const setHeaderHeightVar = () => {
        document.documentElement.style.setProperty('--header-h', `${header.offsetHeight}px`);
    };

    setHeaderHeightVar();
    window.addEventListener('resize', setHeaderHeightVar);
})();
